document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.testimonial-slider');
  const slides = document.querySelectorAll('.testimonial-slide');
  const dots = document.querySelectorAll('.testimonial-dot');
  let currentSlide = 0;
  let autoplay = slider.getAttribute('data-autoplay') === 'true';
  let autoplaySpeed = parseInt(slider.getAttribute('data-speed'), 10) * 1000;
  let slideInterval;

  let isDragging = false;
  let startX = 0;
  let endX = 0;

  function updateSliderHeight() {
    let maxHeight = 0;
    slides.forEach(slide => {
      slide.style.height = 'auto';
      const h = slide.offsetHeight;
      if (h > maxHeight) {
        maxHeight = h;
      }
    });
    slider.style.height = maxHeight + 'px';
    slides.forEach(slide => {
      slide.style.height = '100%';
    });
  }

  function showSlide(index) {
    slides.forEach((slide, idx) => {
      slide.classList.toggle('active', idx === index);
    });
    dots.forEach((dot, idx) => {
      dot.classList.toggle('active', idx === index);
    });
    updateSliderHeight();
  }

  function nextSlide() {
    currentSlide = (currentSlide + 1) % slides.length;
    showSlide(currentSlide);
  }

  function previousSlide() {
    currentSlide = (currentSlide - 1 + slides.length) % slides.length;
    showSlide(currentSlide);
  }

  function startAutoplay() {
    if (autoplay) {
      slideInterval = setInterval(nextSlide, autoplaySpeed);
    }
  }

  function pauseAutoplay() {
    if (autoplay) {
      clearInterval(slideInterval);
    }
  }

  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentSlide = index;
      showSlide(currentSlide);
      pauseAutoplay();
      startAutoplay();
    });
  });

  window.addEventListener('resize', updateSliderHeight);

  slider.addEventListener('mouseenter', pauseAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);

  // Mouse drag events
  slider.addEventListener('mousedown', (e) => {
    isDragging = true;
    startX = e.pageX;
    slider.style.cursor = 'grabbing';
    pauseAutoplay();
  });

  slider.addEventListener('mouseup', (e) => {
    if (isDragging) {
      endX = e.pageX;
      let diff = endX - startX;
      if (Math.abs(diff) > 50) { // threshold to trigger slide
        if (diff < 0) {
          nextSlide();
        } else {
          previousSlide();
        }
      }
      isDragging = false;
      slider.style.cursor = 'grab';
      startAutoplay();
    }
  });

  slider.addEventListener('mouseleave', () => {
    isDragging = false;
    slider.style.cursor = 'grab';
  });

  // Touch drag for mobile
  slider.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
    pauseAutoplay();
  });

  slider.addEventListener('touchend', (e) => {
    endX = e.changedTouches[0].clientX;
    let diff = endX - startX;
    if (Math.abs(diff) > 50) {
      if (diff < 0) {
        nextSlide();
      } else {
        previousSlide();
      }
    }
    startAutoplay();
  });

  // Init
  slider.style.cursor = 'grab';
  showSlide(currentSlide);
  startAutoplay();
});
